import React from 'react';
import { CheckIcon, GiftIcon, GlobeIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { offerItems, offerBonusNames } from '../data/offer';
import { images } from '../data/links';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const perks = ['One-time payment', 'No monthly subscription', 'Instant digital access', 'Lifetime access', '7-Day Guarantee'];
export function Offer() {
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:px-5 sm:py-24" aria-labelledby="offer-title" data-id="element-183" data-mp="p0a2h44i1g5l">
      <div className="mx-auto max-w-2xl" data-id="element-184" data-mp="13xavdayffh5n">
        <div className="text-center" data-id="element-185" data-mp="13uy58aiim0hi">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-gold sm:text-sm" data-id="element-186" data-mp="yxesxg5dnxs7">Special launch offer</p>
          <h2 id="offer-title" className="mt-3 font-heading text-[1.9rem] font-semibold leading-tight text-white sm:text-4xl" data-id="element-187" data-mp="2fbemm9dmqr70">
            Here’s Everything You’ll Receive Today
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-[1.75rem] bg-white shadow-[0_30px_60px_-20px_rgba(0,0,0,0.45)]" data-id="element-188" data-mp="pj5tym718ecy">
          <img src={images.mockup} alt="Everything included in the Praxis & Motor Planning Clinical Pathway" className="w-full bg-mist" data-id="element-189" data-mp="uhqtskidgw0v" />

          <div className="p-5 sm:p-8" data-id="element-190" data-mp="13k00ezais58z">
            <ul className="divide-y divide-line" data-id="element-191" data-mp="13iyrb0d2dstw">
              {offerItems.map(item => <li key={item.title} className="py-5 first:pt-0" data-id="element-192" data-mp="6usgtwtgo67p">
                  <div className="flex items-start justify-between gap-3" data-id="element-193" data-mp="bskj9krqfaq5">
                    <div className="flex gap-3" data-id="element-194" data-mp="bqpt9s1lssf7">
                      <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-ok" aria-hidden="true" data-id="element-195" data-mp="fu5tszgsncx6" />
                      <div data-id="element-196" data-mp="kldyji76ia40">
                        <p className="font-bold leading-snug text-ink" data-id="element-197" data-mp="kmp3hlcd1nwp">{item.title}</p>
                        <p className="text-sm font-semibold text-brand" data-id="element-198" data-mp="3k7ui8k0brztp">{item.subtitle}</p>
                      </div>
                    </div>
                    <span className="shrink-0 text-sm font-bold text-ink/50 line-through decoration-danger/70" data-id="element-199" data-mp="3o7ux25rc6d1a">{item.value}</span>
                  </div>
                  {item.text && <p className="mt-2 pl-8 text-sm leading-relaxed text-ink/65" data-id="element-200" data-mp="qg4hhlzptkg8">{item.text}</p>}
                  {item.title === '5 Professional Bonuses' && <ul className="mt-3 space-y-1.5 pl-8" data-id="element-201" data-mp="105xlo1xj2xag">
                      {offerBonusNames.map(n => <li key={n} className="flex gap-2 text-sm leading-snug text-ink/80" data-id="element-202" data-mp="chxtqyohd0ua">
                          <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-203" data-mp="7il4k7a4zhoj" />
                          {n}
                        </li>)}
                    </ul>}
                </li>)}
            </ul>

            <div className="mt-2 rounded-2xl bg-paper p-5 text-center" data-id="element-204" data-mp="1wwgcje78qm7l">
              <p className="text-sm font-bold uppercase tracking-wider text-ink/60" data-id="element-205" data-mp="1wykmodvqghgb">Total suggested reference value</p>
              <p className="mt-1 text-2xl font-extrabold text-ink/50 line-through decoration-danger decoration-[3px]" data-id="element-206" data-mp="20ex9647o1xvm">USD $244</p>
              <p className="mt-3 font-semibold text-ink" data-id="element-207" data-mp="25ery427vsde1">But you don’t need to pay USD $244.</p>
              <p className="mt-4 text-ink/75" data-id="element-208" data-mp="1qhj5742xj1k7">Get the Complete Praxis & Motor Planning Clinical Pathway™ today for just:</p>
              <p className="mt-2 font-heading text-[4.5rem] font-bold leading-none text-ok sm:text-[5.5rem]" data-id="element-209" data-mp="1vg2pz15se7az">
                <span className="align-top text-2xl font-sans font-extrabold sm:text-3xl" data-id="element-210" data-mp="2j5x0vd6jplsl">USD </span>$27
              </p>
              <p className="mt-1 text-sm font-bold uppercase tracking-wider text-ink/60" data-id="element-211" data-mp="29fbw180a3l18">One-time payment</p>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-212" data-mp="2edx0jjmkcqvh">
              {perks.map(p => <li key={p} className="rounded-full bg-okSoft px-3 py-1.5 text-xs font-bold text-ok sm:text-sm" data-id="element-213" data-mp="323r6ricdnh6r">
                  {p}
                </li>)}
            </ul>

            <div className="mt-6" data-id="element-214" data-mp="1j6xpjjqokl2t">
              <ScarcityBar data-id="element-215" data-mp="1j7zbwkd5ctzu" />
            </div>

            <div className="mt-6 flex flex-col items-center" data-id="element-216" data-mp="1e7l14uk5v5y4">
              <CtaButton label="Get instant access now" className="sm:w-full" data-id="element-217" data-mp="1e607r89l1t1u" />
            </div>

            <div className="mt-6 rounded-2xl bg-ink px-4 py-5 text-center" data-id="element-218" data-mp="198gry3x8l87s">
              <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-219" data-mp="14afafnfglgyf">This special price ends in</p>
              <CountdownTimer tone="light" size="md" data-id="element-220" data-mp="21w4cxk2f60uy" />
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-mist p-4" data-id="element-221" data-mp="1wz4451e6qk05">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-222" data-mp="1s6axu932j3ly" />
              <p className="text-sm leading-relaxed text-ink/80" data-id="element-223" data-mp="1n8rljepxl0wn">
                <strong className="text-ink" data-id="element-224" data-mp="1n65bn8fki9b9">Automatic currency conversion.</strong> Your payment provider will display the
                equivalent amount in your local currency at checkout.
              </p>
            </div>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-ink/60" data-id="element-225" data-mp="2o5t40i44updf">
              <span className="flex items-center gap-1.5" data-id="element-226" data-mp="2s7o7nt9jdeud">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-227" data-mp="2x696bo953qgp" /> Secure checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-228" data-mp="325lss7w3mvir">
                <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-229" data-mp="322zlm9d4ei12" /> Encrypted payment
              </span>
            </div>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-sm leading-relaxed text-white/75" data-id="element-230" data-mp="3b4pcne33beyb">
          For less than the cost of many professional reference materials, you’ll have an educational toolkit you can return
          to whenever you need help organizing a pediatric praxis or motor planning case.
        </p>
      </div>
    </section>;
}